const API_URL = import.meta.env.VITE_API_GRAPHQL_URL;

const collectUploads = (value, path, uploads) => {
	if (value instanceof File || value instanceof Blob) {
		uploads.push({ path, file: value });
		return null;
	}

	if (Array.isArray(value)) {
		return value.map((item, index) =>
			collectUploads(item, `${path}.${index}`, uploads),
		);
	}

	if (value && typeof value === 'object') {
		return Object.fromEntries(
			Object.entries(value).map(([key, nested]) => [
				key,
				collectUploads(nested, `${path}.${key}`, uploads),
			]),
		);
	}

	return value;
};

export const graphqlUpload = async ({ query, variables }) => {
	const uploads = [];
	const sanitizedVariables = collectUploads(variables, 'variables', uploads);

	if (!uploads.length) {
		const response = await fetch(API_URL, {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ query, variables: sanitizedVariables }),
		});

		return response.json();
	}

	const formData = new FormData();
	const map = {};

	uploads.forEach((upload, index) => {
		map[index] = [upload.path];
		formData.append(String(index), upload.file);
	});

	formData.append(
		'operations',
		JSON.stringify({ query, variables: sanitizedVariables }),
	);
	formData.append('map', JSON.stringify(map));

	const response = await fetch(API_URL, {
		method: 'POST',
		credentials: 'include',
		body: formData,
	});

	return response.json();
};
